// React-Screen CProductCategoriesMode ("Produktgruppenauswahl") - Strangler
// Phase 5, Klasse B. Runbook: tools/REACT-STRANGLER.md.
// Ersetzt die ESM-Huelle productcategoriesmode.js (aus
// lib/scripts/pos/components/CMP_CProductCategoriesMode.js).
// Legacy-DOM-Fixture: tests/react-fixtures/CProductCategoriesMode.html,
// gezogen aus tests/visual-baseline/25-overlay-warengruppen.html.
//
// Gleicher Bauplan wie CCancelBonMode: async prepare() mit SQL, und die
// Gruppen-Knoepfe stehen in einem geblaetterten Raster - seit 23.8.2026
// gerendert von PagedPushPanel (react/widgets.jsx) statt vom Legacy-Widget.
// Dieser Screen ist der EINZIGE portierte mit mehr als einer Seite und
// deshalb der Beleg, dass die Blaetterknoepfe stimmen (Suite-Fall
// "Blaettern im Knopf-Raster der Warengruppen-Auswahl").
// Geoeffnet aus CMainPOS.productCategories - das verlangt einen Betrag im
// Universalfeld.
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';
import { PagedPushPanel, verdrahtePagedPushPanel } from '../widgets.jsx';

// Legacy-CCaption: innerHTML = value UND class = "CCaption <addclass> <value>".
function Caption({ bridge, path, addclass, value, style }) {
  const cls = 'CCaption' + (addclass ? ' ' + addclass : '') + ' ' + value;
  return <p {...bridge.el(path, 'CCaption')} className={cls} style={style}
            dangerouslySetInnerHTML={{ __html: value }} />;
}

function ProductCategoriesModeScreen({ bridge }) {
  const t = bridge.t;
  // Legacy: okButton bleibt ein CPushButton ohne Handler, aber unsichtbar.
  const okButton = bridge.widget('7', 'CPushButton', {
    events: { onMousedown: true, onMouseout: true, onMouseup: true },
    proto: CPushButton.prototype,
  });
  // Legacy: backButton.properties.events.onMousedown = this.cancel
  const backButton = bridge.widget('8', 'CPushButton', {
    events: { onMousedown: () => bridge.finish(), onMouseout: true, onMouseup: true },
    attributes: { onMousedown_parameter_0: bridge.id },
    proto: CPushButton.prototype,
  });

  return (
    <>
      {/* wholeOverlay - Legacy setzt Groesse/Position erst nach dem SQL */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame wholeoverlay"
           style={{ position: 'absolute', visibility: 'visible', height: '100%',
                    width: '31vw', top: '0px', left: '70%' }}></div>
      {/* overlay */}
      <div {...bridge.el('1', 'CFrame')} className="CFrame overlay" style={{ position: 'absolute' }}></div>
      {/* titleBack */}
      <div {...bridge.el('2', 'CFrame')} className="CFrame titleback" style={{ position: 'absolute' }}></div>
      {/* titleText */}
      <Caption bridge={bridge} path="3" addclass="titletext" value={t('LABELS', 'GROUP_SELECT_MODE')} />
      {/* contentText */}
      <Caption bridge={bridge} path="4" addclass="contenttext"
               value={t('LABELS', 'GROUP_SELECT_MODE_TEXT')} style={{ fontSize: '15px' }} />
      {/* priceText */}
      <Caption bridge={bridge} path="5" addclass="pricetext" value=" " />
      {/* unitsText */}
      <Caption bridge={bridge} path="6" addclass="unitstext" value=" " />
      {/* okButton */}
      <div {...okButton} className="CPushButton okbutton" style={{ visibility: 'hidden' }}>
        <Caption bridge={bridge} path="7:0" addclass="" value=" " />
      </div>
      {/* backButton */}
      <div {...backButton} className="CPushButton backbutton">
        <p {...bridge.el('8:0', 'CCaption')} className="CCaption undefined"></p>
      </div>
      {/* selectPanel: die Warengruppen. Seit 23.8.2026 ein React-Knoten -
          4 Spalten x 3 Zeilen aus LYT_bonOverlayPagedPanel.xml, also 12
          Plaetze pro Seite. Dieser Screen ist der erste mit MEHR als einer
          Seite und damit der einzige Beleg, dass die Blaetterknoepfe in
          PagedPushPanel stimmen. */}
      <PagedPushPanel bridge={bridge} pfad="9" zeilen={3} spalten={4}
                      knoepfe={bridge.gruppenKnoepfe || []} />
    </>
  );
}

export const CProductCategoriesMode = defineReactScreen({
  className: 'CProductCategoriesMode',
  addclass: 'CProductCategoriesMode CashWindow',
  htmlType: 'div',
  Screen: ProductCategoriesModeScreen,
  prepare(bridge) {
    bridge.Main = POS.sessions.getSessionComponent();

    bridge.Main.components.payment.setEnabled(false);
    bridge.Main.components.payment2.setEnabled(false);
    bridge.Main.components.bonfnc.setEnabled(false);
    bridge.Main.components.leftPad.setEnabled(false);
    bridge.Main.components.numPad.setEnabled(false);
    bridge.Main.components.bonedit.setEnabled(false);
    bridge.Main.components.info.setEnabled(false);

    // NEU (Nutzer-OK 21.8.2026 "beim Umstellen fixen"), kein Legacy-Wert:
    // derselbe Fund wie bei CRebatesInfoMode. .CashWindow setzt
    // visibility:hidden, und dieser Screen holte die Sichtbarkeit nirgends
    // zurueck. Sichtbar war nur das CPagedPushPanel (das seine Sichtbarkeit
    // selbst setzt) - Titel "Produktgruppenauswahl", der Hinweistext und der
    // Abbrechen-Knopf blieben unsichtbar, und ein unsichtbarer Knopf ist
    // nicht anklickbar (document.elementFromPoint lieferte den
    // wholeOverlay-Schleier). Der Screen liess sich also nur verlassen,
    // indem man IRGENDEINE Warengruppe buchte. Behoben wie bei COnlyPayMode.
    bridge.properties.styles.visibility = 'visible';

    // Die Warengruppen kommen aus der DB. Frueher stand das SQL in
    // mountLegacy, weil dort der Widget-Baum gebaut wurde; jetzt braucht
    // React die Daten schon beim Rendern - also hier, und prepare darf ein
    // Deferred zurueckgeben.
    const defret = jQuery.Deferred();

    // SQL-Text ZEICHENGENAU wie im Legacy (Master/Slave-Routing).
    var sql = 'SELECT FREEPROD_ID, Text1, Text2 FROM FREEPROD'; // WHERE Parent_BTN_ID = 0;"; (man kann es nicht so machen weil es in der Tabelle "BTN" das VAT-Feld fehlt)
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
      bridge.gruppenKnoepfe = rows.map((zeile) => ({
        text: (zeile.Text1 ? zeile.Text1 : '') + (zeile.Text2 ? ('<br>' + zeile.Text2) : ''),
        handler: (component, parameters) => bridge.addGroup(component, parameters),
        param0: bridge.id,
        param1: zeile.FREEPROD_ID,
      }));
      defret.resolve();
    });

    return defret.promise();
  },
  // Nach dem Mount nur noch VERDRAHTUNG: Name wie in der XML und die Seiten
  // verketten, damit die Blaetterknoepfe weiterschalten koennen.
  mountLegacy(bridge) {
    bridge.nameComponent('9', 'selectPanel');
    verdrahtePagedPushPanel(bridge, '9');
  },
  methods: {
    // Klick auf eine Warengruppe: bucht den Betrag und schliesst.
    addGroup(bridge, component, parameters) {
      var freeProdId = parameters[1];

      $.when(bridge.Main.BonManager.addEntryFREE(bridge.amount, freeProdId, bridge.mode)).done(function () {
        bridge.finish();
      });
    },
    restoreMainPos(bridge) {
      bridge.Main.components.payment.setEnabled(true);
      bridge.Main.components.payment2.setEnabled(true);
      bridge.Main.components.bonfnc.setEnabled(true);

      bridge.Main.components.leftPad.setEnabled(true);
      bridge.Main.components.numPad.setEnabled(true);
      bridge.Main.components.bonedit.setEnabled(true);
      bridge.Main.components.info.setEnabled(true);
    },
    finish(bridge) {
      bridge.restoreMainPos();
      bridge.Main.vacuumInfoValue(bridge.Main);

      log.add(4, 'Info', 'product categories off', '');

      bridge.removeMe();
    },
  },
});
